/* MEDILIFE 2026 — interacciones del tema (header, buscador, menu movil, tabs, rieles, reveal) */
(function(){
  document.documentElement.classList.add('mdl-js');
  var $ = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var lock = function(on){document.documentElement.style.overflow = on ? 'hidden' : '';};

  function initHeader(){
    var header = $('.mdl-header');
    if(!header || header.dataset.mdlInit) return;
    header.dataset.mdlInit = '1';
    var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

    // mega menu: abre con hover en escritorio y con clic/teclado
    $$('.mdl-nav__item[data-mega]').forEach(function(item){
      var t; var btn = $('.mdl-nav__link', item);
      var open = function(){ clearTimeout(t); $$('.mdl-nav__item.is-open').forEach(function(o){ if(o!==item) o.classList.remove('is-open'); }); item.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); };
      var close = function(){ t = setTimeout(function(){ item.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); }, 140); };
      item.addEventListener('mouseenter', open); item.addEventListener('mouseleave', close);
      btn.addEventListener('click', function(e){ e.preventDefault(); item.classList.contains('is-open') ? (item.classList.remove('is-open'), btn.setAttribute('aria-expanded','false')) : open(); });
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ $$('.mdl-nav__item.is-open').forEach(function(o){o.classList.remove('is-open');}); closeSearch(); closeDrawer(); } });

    // buscador
    var search = $('.mdl-search');
    function openSearch(){ if(!search) return; search.classList.add('is-open'); lock(true); setTimeout(function(){ var i=$('input[type="search"]',search); i && i.focus(); }, 60); }
    function closeSearch(){ if(!search || !search.classList.contains('is-open')) return; search.classList.remove('is-open'); lock(false); }
    window.mdlCloseSearch = closeSearch;
    $$('[data-mdl-search-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openSearch(); }); });
    $$('[data-mdl-search-close]').forEach(function(b){ b.addEventListener('click', closeSearch); });
    search && search.addEventListener('click', function(e){ if(e.target===search) closeSearch(); });

    // drawer movil
    var drawer = $('.mdl-drawer');
    function openDrawer(){ if(!drawer) return; drawer.classList.add('is-open'); lock(true); }
    function closeDrawer(){ if(!drawer || !drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); lock(false); }
    window.mdlCloseDrawer = closeDrawer;
    $$('[data-mdl-drawer-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });
    $$('[data-mdl-drawer-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });

    // contador del carrito: se refresca cuando el carrito cambia (iCart / fetch del tema)
    var refresh = function(){ fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){ $$('.mdl-cart-count').forEach(function(el){ el.textContent=c.item_count; el.setAttribute('data-count', c.item_count); }); }).catch(function(){}); };
    var _f = window.fetch;
    if(_f && !window.__mdlFetchWrapped){
      window.__mdlFetchWrapped = true;
      window.fetch = function(){ var u = arguments[0] && (arguments[0].url || arguments[0]); var p = _f.apply(this, arguments);
        if(typeof u==='string' && /\/cart\/(add|change|update|clear)/.test(u)) p.then(function(){ setTimeout(refresh, 250); });
        return p; };
    }
    document.addEventListener('cart:updated', refresh);
  }

  function initTabs(root){
    $$('[data-mdl-tabs]', root).forEach(function(box){
      if(box.dataset.mdlInit) return; box.dataset.mdlInit='1';
      var tabs = $$('[role="tab"]', box), panels = $$('[role="tabpanel"]', box);
      tabs.forEach(function(tab, i){ tab.addEventListener('click', function(){
        tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
        panels.forEach(function(p){ p.hidden = true; });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected','true'); panels[i].hidden = false;
        var more = $('[data-mdl-tab-more]', box); if(more && tab.dataset.url){ more.href = tab.dataset.url; }
      }); });
    });
  }

  function initRails(root){
    $$('[data-mdl-rail]', root).forEach(function(wrap){
      if(wrap.dataset.mdlInit) return; wrap.dataset.mdlInit='1';
      var rail = $('.mdl-rail', wrap); if(!rail) return;
      $$('[data-mdl-rail-dir]', wrap).forEach(function(b){ b.addEventListener('click', function(){
        var visible = $$('.mdl-tabpanel:not([hidden]) .mdl-rail', wrap)[0] || rail;
        visible.scrollBy({left: (+b.dataset.mdlRailDir) * visible.clientWidth * .9, behavior:'smooth'});
      }); });
    });
  }

  function initReveal(root){
    var els = $$('.mdl-reveal:not(.is-in)', root);
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function initCollection(){
    $$('[data-mdl-sort]').forEach(function(sel){
      if(sel.dataset.mdlInit) return; sel.dataset.mdlInit='1';
      sel.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
    $$('[data-mdl-instock]').forEach(function(chk){
      if(chk.dataset.mdlInit) return; chk.dataset.mdlInit='1';
      chk.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.delete('page');
        if(chk.checked) u.searchParams.set('filter.v.availability','1'); else u.searchParams.delete('filter.v.availability');
        location.href = u.toString(); });
    });
  }

  function initAll(root){ initHeader(); initTabs(root); initRails(root); initReveal(root); initCollection(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); $$('.mdl-reveal', e.target).forEach(function(x){x.classList.add('is-in');}); });
})();
